import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";

export default styled(Slider)(({ theme }) => ({
  color: theme.palette.secondary.main,
  height: 2,
  "& .MuiSlider-thumb": {
    width: 20,
    height: 20,
    boxSizing: "content-box",
    border: "0.25rem solid",
    borderColor: theme.palette.background.default,
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    backgroundColor: theme.palette.grey[500],
  },
  "& .MuiSlider-valueLabel": {
    background: "transparent",
    color: "currentColor",
    top: 5,
  },
  "& .MuiSlider-track": {
    border: "none",
    color: theme.palette.primary.main,
  },
  "& .MuiSlider-markLabel": {
    color: "currentColor",
  },
  "& .MuiSlider-mark": {
    height: 15,
    width: 2,
    backgroundColor: theme.palette.grey[500],
    "&.MuiSlider-markActive": {
      opacity: 1,
      backgroundColor: "currentColor",
    },
    '&[style*="left: 0%"],&[style*="left: 100%"]': {
      width: 20,
      height: 20,
      borderRadius: "50%",
      border: "0.25rem solid",
      borderColor: theme.palette.background.default,
      transform: "translate(-12px,-50%)",
    },
  },
}));
